/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkPrintRequest } from '../../models/bulk-print-request';
import { CreateBulkPrintRequestDto } from '../../models/create-bulk-print-request-dto';

export interface CreateBulkPrintRequest$Params {
  body: CreateBulkPrintRequestDto;
}

export function createBulkPrintRequest(
  http: HttpClient,
  rootUrl: string,
  params: CreateBulkPrintRequest$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<BulkPrintRequest>> {
  const rb = new RequestBuilder(rootUrl, createBulkPrintRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BulkPrintRequest>;
    })
  );
}

createBulkPrintRequest.PATH = '/bulk-print';
